<template>
    <v-card class="cardBgColorStyle" >

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> {{formTitle}} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md >

                <v-layout wrap row xs12 sm12 md12>


                    <v-flex xs12 sm12 md4 d-inline-flex>
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >院區代號*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>
                            <v-select
                                    :disabled="this.editIndex!=-1"
                                    v-if="this.zoneNameList.length>0"
                                    v-model="zone"
                                    hide-details
                                    :items="zoneNameList"
                                    :item-text="zoneItemText"
                                    item-value="zone"
                            ></v-select>
                            <v-text-field v-else  :rules="[rules.required]" :disabled="this.editIndex!=-1"  v-model="zone"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <!--判斷類別 1101129新增  -->
                    <v-flex xs12 sm12 md4 d-inline-flex>
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >判斷類別*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>

                            <v-select
                                    :disabled="this.editIndex!=-1"
                                    :rules="[rules.required]"
                                    :items="judgeTypeList"
                                    item-value="key"
                                    :item-text="judgeTypeItemText"
                                    v-model="judgeType"
                            ></v-select>

                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md4 d-inline-flex>
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >診間/醫師/科別代號*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>
                            <v-text-field :rules="[rules.required]"  :disabled="this.editIndex!=-1"  v-model="clinicNo"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md4 d-inline-flex>
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >判斷序號*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>

                            <v-text-field :rules="[rules.required]"  :disabled="this.editIndex!=-1"  v-model="chkOrder"   clearable></v-text-field>

                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md4 d-inline-flex>
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >檢查類別</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>

                            <v-select
                                    :items="chkTypeList"
                                    item-value="value"
                                    item-text="key"
                                    v-model="chkType"
                            ></v-select>

                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md4 d-inline-flex>
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >值型態*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>

                            <v-select
                                    :items="valTypeList"
                                    item-value="value"
                                    item-text="key"
                                    v-model="valType"
                            ></v-select>

                        </v-flex>
                    </v-flex>



                    <v-flex xs12 sm12 md4 d-inline-flex>
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >操作符號*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>

                            <v-select
                                    :items="operList"
                                    item-value="value"
                                    item-text="key"
                                    v-model="oper"
                            ></v-select>

                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md4 d-inline-flex>
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >值1</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>
                            <v-text-field     v-model="val1"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md4 d-inline-flex>
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >值2</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>
                            <v-text-field     v-model="val2"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md4 d-inline-flex>
                        <v-flex xs5 sm5 md6 text-right  class="labelFont">
                            <v-label >有效否:</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md6 pl-2>
                            <v-switch color="primary" hide-details :label="`${effFlag==true?'有效':'無效'}`" v-model="effFlag"></v-switch>
                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >提示內容</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-textarea  filled rows="4" auto-grow :value="promptNote"  v-model="promptNote"  clearable ></v-textarea>
                        </v-flex>
                    </v-flex>


                </v-layout>


            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeDialog">取消</v-btn>
            <v-btn  @click.native="save">送出</v-btn>
        </v-card-actions>



    </v-card>
</template>

<script>
    export default {
        name: "EditClinicChk",
        props:['editIndex','isShow','editObj','zoneNameList'],
        data() {
            return {
                zone:'',//院區代號
                judgeType:'',//判斷類別
                clinicNo:'',// 診間代號
                chkOrder:'',//時段
                valType:'',//值型態
                chkType:'',// 提示事件類別
                oper:'',// 操作符號
                val1:'',// 值1
                val2:'',// 值2
                promptNote:'',// 提示內容
                effFlag:'',//有效否
                modifyObj:{},
                rules:{
                    required: value => !!value || '必填.',

                },
                chkTypeList:[
                    {key:'SEX-性別',value:'SEX'},
                    {key:'AGE-年齡(年)',value:'AGE'},
                    {key:'AGEMON-年齡(月)',value:'AGEMON'},
                    {key:'AGEDAY-年齡(日)',value:'AGEDAY'},
                ],
                valTypeList:[
                    {key:'STRING',value:'STRING'},
                    {key:'NUMBER',value:'NUMBER'},
                    {key:'BOOLEAN',value:'BOOLEAN'},
                ],
                judgeTypeList:[
                    {key:'CLINIC',value:'診間'},
                    {key:'DOCTOR',value:'醫師'},
                    {key:'DIVISION',value:'科別'},
                ],
                operList:[
                    {key:'<',value:'<'},
                    {key:'>',value:'>'},
                    {key:'=',value:'='},
                    {key:'<=',value:'<='},
                    {key:'>=',value:'>='},
                    {key:'!=',value:'!='},
                    {key:'BETWEEN',value:'BETWEEN'},
                ]
            }
        },
        watch:{
            isShow(val){
                if(val==true&this.editIndex!=-1){
                    this.zone = this.editObj.zone==undefined?'':this.editObj.zone;
                    this.judgeType = this.editObj.judgeType==undefined?'':this.editObj.judgeType;
                    this.chkOrder = this.editObj.chkOrder==undefined?'':this.editObj.chkOrder;
                    this.clinicNo = this.editObj.clinicNo==undefined?'':this.editObj.clinicNo;
                    this.chkType = this.editObj.chkType==undefined?'':this.editObj.chkType;
                    this.promptNote = this.editObj.promptNote==undefined?'':this.editObj.promptNote;
                    this.valType = this.editObj.valType==undefined?'':this.editObj.valType;
                    this.oper = this.editObj.oper==undefined?'':this.editObj.oper;
                    this.val1 = this.editObj.val1==undefined?'':this.editObj.val1;
                    this.val2 = this.editObj.val2==undefined?'':this.editObj.val2;
                    let effFlag = this.editObj.effFlag==undefined?'':this.editObj.effFlag;
                    this.effFlag = effFlag=='Y'?true:false;
                }else {
                    this.zone ='A';
                    this.chkOrder = '';
                    this.chkType = '';
                    this.clinicNo = '';
                    this.promptNote = '';
                    this.valType = '';
                    this.oper = '';
                    this.val1 = '';
                    this.val2 = '';
                    this.effFlag = true;
                    this.judgeType = '';
                }

            }
        },
        computed:{
            formTitle () {
                return this.editIndex == -1 ? '新增 診間掛號條件設定' : '編輯 診間掛號條件設定'
            },
        },
        methods:{
            judgeTypeItemText: item => item.key + '-' + item.value, //格式化 autocomplete 選權限顯示文字
            zoneItemText: item => item.zone==''?'':item.zone + '-' + item.zoneName, //格式化 院區顯示文字
            closeDialog(){
                this.$emit('closeDialog');
            },
            save(){
                if(this.editIndex==-1){ //新增狀態
                    this.modifyObj = {
                        zone : this.zone==''||this.zone==null||this.zone==undefined?'':this.zone,
                        chkOrder : this.chkOrder,
                        judgeType : this.judgeType,
                        chkType: this.chkType,
                        clinicNo: this.clinicNo,
                        promptNote: this.promptNote,
                        valType: this.valType,
                        oper: this.oper,
                        val1: this.val1,
                        val2: this.val2,
                        effFlag: this.effFlag==true?'Y':'N',


                    }
                }else { //修改狀態
                    this.modifyObj = {
                        zone : this.zone==''||this.zone==null||this.zone==undefined?'':this.zone,
                        chkOrder : this.chkOrder ,
                        chkType: this.chkType,
                        clinicNo: this.clinicNo,
                        promptNote: this.promptNote,
                        valType: this.valType,
                        judgeType : this.judgeType,
                        oper: this.oper,
                        val1: this.val1,
                        val2: this.val2,
                        effFlag: this.effFlag==true?'Y':'N',
                    }
                }
                // parseFloat(this.sortByNo).toFixed(1);
                if(this.zone==''||this.chkOrder==''||this.clinicNo==''||this.judgeType==''){
                    alert('請確認是否輸入院區代號、判斷類別，診間/醫師/科別代號、判斷序號')
                }else {
                    this.$emit('save',this.modifyObj);
                }

            }
        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }


</style>